<template>
  <div :class="setFormClass">
    <input
      type="radio"
      :id="radioId"
      :name="name"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('change', value)" />
    <label :for="radioId"><slot></slot></label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checkValue',
    event: 'change',
  },
  props: {
    inline: Boolean,
    name: String,
    value: String,
    checked: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      formClass: 'fx_form',
    };
  },
  computed: {
    setFormClass() {
      if (this.inline) return `${this.formClass} inline`;
      return this.formClass;
    },
    radioId() {
      return `radio${this.value}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/control/radio/Radio.vue